<ng-container [formGroup]="form">
    <div class="form-field">
        <mat-checkbox i18n formControlName="enabled">Only show this field based upon the completion of another field on this form</mat-checkbox>
    </div>
    <fieldset *ngIf="isEnabled">
        <mat-form-field appearance="outline" requied>
            <mat-label i18n>This field is</mat-label>
            <mat-select formControlName="visibility">
                <mat-option *ngFor="let visibility of availableVisibility" [value]="visibility.id" [value]="visibility.id">
                    {{ visibility.name }}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" required>
            <mat-label i18n>when field</mat-label>
            <mat-select formControlName="target">
                <mat-option *ngFor="let field of availableFields" [value]="field.id">
                    {{ field.name }}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" required>
            <mat-label i18n>value</mat-label>
            <mat-select formControlName="operator">
                <mat-option *ngFor="let operator of targetScopedOperators" [value]="operator.id">
                    {{ operator.name }} 
                </mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" *ngIf="targetIsBooleanType">
            <mat-label i18n>is...</mat-label>
            <mat-select formControlName="value">
                <mat-option [value]="true" i18n>Yes</mat-option>
                <mat-option [value]="false" i18n>No</mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" *ngIf="!targetIsBooleanType && !targetHasDiscreteValues">
            <mat-label i18n>to...</mat-label>
            <input matInput formControlName="value" placeholder="Field value">
        </mat-form-field>
        <mat-form-field appearance="outline" *ngIf="!targetIsBooleanType && targetHasDiscreteValues">
            <mat-label i18n>of...</mat-label>
            <mat-select *ngIf="targetHasDiscreteValues" formControlName="value" multiple>
                <mat-option *ngFor="let value of targetDiscreteValues" [value]="value.id" [title]="value.name">
                    {{ value.name }}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </fieldset>
</ng-container>
